<template>
  <div class="app-container crm-follow-list">
    <el-form :model="queryParams" ref="queryForm" v-show="showSearch" label-width="100px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="所属类型" prop="targetTypeList">
            <el-select v-model="queryParams.targetTypeList" clearable multiple style="width:100%">
              <el-option v-for="dict in targetTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="跟进类型" prop="followReplyType">
            <el-select v-model="queryParams.followReplyType" clearable style="width:100%">
              <el-option key="1" label="跟进" value="1"/>
              <el-option key="2" label="回复" value="2"/>
            </el-select>
          </el-form-item>
        </el-col>
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :userLabel="'跟进回复人'" :userIdField="'createByList'"></dept-user-select>
      </el-row>
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="跟进回复时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :md="12" :lg="6" :offset="18" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="所属类型" width="120" align="center">
        <template slot-scope="scope">
          <el-tag v-if="isPhaseFollow(scope.row)" size="mini" type="warning">合同阶段</el-tag>
          <span v-else>{{scope.row.targetTypeDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column label="名称" min-width="100" align="center">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.targetName}}</el-link>
          <div v-if="isPhaseFollow(scope.row)" class="phase-name">{{scope.row.contractPhaseName || '阶段进展'}}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属部门" min-width="100" align="center" prop="followerDept" show-overflow-tooltip/>
      <el-table-column label="跟进类型" min-width="100" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{getFollowTypeText(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="跟进回复人" width="150" align="center" prop="followerName"/>
      <el-table-column label="跟进回复时间" width="200" align="center" prop="createTime" />
      <el-table-column label="跟进回复内容" min-width="300" align="left">
        <template slot-scope="scope">
          <div style="text-align: left;">
            <span class="content">{{getFollowContentText(scope.row) || getFollowFileText(scope.row)}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import {listFollow} from "@/api/crm/follow";
import {businessTargetTypeToPath} from "@/utils/crm";
import deptUserSelect from "@/views/crm/components/deptUserSelect";

export default {
  name: "FollowManage",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      targetTypeOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        followReplyType: null,
        targetTypeList: [],
        deptIdList: [],
        createByList: [],
        createTime: [],
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    deptUserSelect
  },
  created() {
    this.queryParams.createByList = [this.currentUserId]
    this.getList();
    this.getDicts("business_type").then(response => {
      this.targetTypeOptions = response.data;
    });
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0]
        params.endDate = params.createTime[1]
      }
      params.createTime = undefined;
      listFollow(params).then(response => {
          this.dataList = response.rows;
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.deptIdList = [];
      this.queryParams.createByList = [];
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/" + businessTargetTypeToPath(row.targetType) + "/detail/" + row.targetId, "_blank")
    },
    isPhaseFollow(row) {
      return !!(row && (row.contractPhaseId || row.contractPhaseName || row.followType === '阶段进展'))
    },
    getFollowTypeText(row) {
      if (this.isPhaseFollow(row)) {
        return row.followReplyType === 2 ? '阶段进展回复' : '阶段进展'
      }
      return row.followReplyTypeDesc || ''
    },
    getFollowContentText(row) {
      const candidates = [
        row && row.plainContent,
        row && row.content
      ]
      for (let i = 0; i < candidates.length; i++) {
        const text = this.normalizeFollowContent(candidates[i])
        if (text) {
          return text
        }
      }
      return ''
    },
    getFollowFileText(row) {
      const files = this.normalizeFollowFiles(row && (row.fileObjs || row.files || row.fileList || row.attachments))
      return files.length ? `已上传附件 ${files.length} 个` : ''
    },
    normalizeFollowFiles(value) {
      if (!value) {
        return []
      }
      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }
      if (typeof value === 'string') {
        const text = value.trim()
        if (!text) {
          return []
        }
        if (text.startsWith('[') || text.startsWith('{')) {
          try {
            const parsed = JSON.parse(text)
            return Array.isArray(parsed) ? parsed.filter(Boolean) : [parsed]
          } catch (e) {
            return []
          }
        }
      }
      if (typeof value === 'object') {
        return [value]
      }
      return []
    },
    normalizeFollowContent(value) {
      if (value === undefined || value === null) {
        return ''
      }
      const raw = String(value).trim()
      if (!raw || raw === '[]') {
        return ''
      }
      if (!raw.startsWith('[')) {
        return raw
      }
      try {
        const list = JSON.parse(raw)
        if (!Array.isArray(list)) {
          return raw
        }
        return list.map(item => {
          if (!item) {
            return ''
          }
          if (item.type === 1 && item.atUser) {
            return `@${item.atUser.nickName || item.atUser.userName || item.atUser.name || ''} `
          }
          return item.content || item.text || ''
        }).join('').trim()
      } catch (e) {
        return raw
      }
    }
  }
};
</script>

<style lang='scss'>
.crm-follow-list {
  .content {
    word-break: break-all;
    line-height: 1.5em;
  }
  .phase-name {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
  }
}
</style>
